var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(-1319 -77)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(1319 77)",
    fill: "#a4a2dc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "note-pencil",
    transform: "translate(1145.205 -210.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9715",
    "data-name": "Path 9715",
    d: "M260.061,297.208l-2.253-2.253a.458.458,0,0,0-.647,0l-1.69,1.69h0l-5.07,5.07a.458.458,0,0,0-.134.324v2.253a.458.458,0,0,0,.458.458h2.253a.458.458,0,0,0,.324-.134l6.76-6.76A.458.458,0,0,0,260.061,297.208Zm-7.274,6.626h-1.606v-1.606l4.612-4.612,1.606,1.606Zm5.26-5.26-1.606-1.606,1.043-1.043,1.606,1.606Z",
    transform: "translate(-64.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9716",
    "data-name": "Path 9716",
    d: "M194.21,310.3a.458.458,0,0,0-.458.458v6.2a.106.106,0,0,1-.106.106H182.38a.106.106,0,0,1-.106-.106V305.685a.106.106,0,0,1,.106-.106h6.2a.458.458,0,0,0,0-.916h-6.2a1.022,1.022,0,0,0-1.021,1.021v11.267a1.022,1.022,0,0,0,1.021,1.021h11.267a1.022,1.022,0,0,0,1.021-1.021v-6.2A.458.458,0,0,0,194.21,310.3Z",
    transform: "translate(0 -9.28)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilRound);
export default __webpack_public_path__ + "static/media/pencil-round.fa233d26e72344cdfb115c98b0ca8ed5.svg";
export { ForwardRef as ReactComponent };